import { without } from 'lodash';
import { labeled, enumRequired, stringRequired } from '../../util/joi';
import { ImportantOption, importantOptions } from '../global/ImportantOption.enum';
import { FrequencyOption, frequencyOptions } from '../global/FrequencyOption.enum';

export const schema = (Joi: any, label: string) => {
  const availableImportantOptions = without(
    importantOptions,
    ImportantOption.none.name,
    ImportantOption.important.name,
    ImportantOption.not_important.name,
    ImportantOption.do_not_want.name
  );
  const availableFrequencyOptions = without(frequencyOptions, FrequencyOption.none.name);

  return Joi.object()
    .keys({
      lowestOverallLoanCost: enumRequired(
        Joi,
        availableImportantOptions,
        labeled(label, 'Lowest overall loan cost')
      ),

      loanApprovedQuickly: enumRequired(
        Joi,
        availableImportantOptions,
        labeled(label, 'Loan approved quickly')
      ),

      specificLoanFeatures: enumRequired(
        Joi,
        availableImportantOptions,
        labeled(label, 'Specific loan features')
      ),

      lenderPolicy: enumRequired(
        Joi,
        availableImportantOptions,
        labeled(label, 'Lender policy/borrowing capacity')
      ),

      goToBranch: enumRequired(
        Joi,
        availableFrequencyOptions,
        labeled(label, 'How often do you go to a branch?')
      ),
      useInternetBanking: enumRequired(
        Joi,
        availableFrequencyOptions,
        labeled(label, 'How often do you use internet banking?')
      )
    })
    .when('.lowestOverallLoanCost.name', {
      is: ImportantOption.most_important.name,
      then: Joi.object().keys({
        lowestOverallLoanCostComments: stringRequired(Joi, 1, 4096).label(
          labeled(label, 'Lowest overall loan cost - Comments')
        )
      })
    })
    .when('.loanApprovedQuickly.name', {
      is: ImportantOption.most_important.name,
      then: Joi.object().keys({
        loanApprovedQuicklyComments: stringRequired(Joi, 1, 4096).label(
          labeled(label, 'Loan approved quickly - Comments')
        )
      })
    })
    .when('.specificLoanFeatures.name', {
      is: ImportantOption.most_important.name,
      then: Joi.object().keys({
        specificLoanFeaturesComments: stringRequired(Joi, 1, 4096).label(
          labeled(label, 'Specific loan features - Comments')
        )
      })
    })
    .when('.lenderPolicy.name', {
      is: ImportantOption.most_important.name,
      then: Joi.object().keys({
        lenderPolicyComments: stringRequired(Joi, 1, 4096).label(
          labeled(label, 'Lender policy/borrowing capacity - Comments')
        )
      })
    });
};

export default {
  schema
};
